import { useContext, createContext } from 'react'

type CreateLayoutContextValue<T> = {
  isSectionActive: (step: T) => boolean
}

export const CreateLayoutContext = createContext({} as CreateLayoutContextValue<any>)
export const useCreateLayoutContext = () => useContext(CreateLayoutContext)
